module.exports = __webpack_public_path__ + "bitcoin-cash-bch-logo.svg?0afaa6a2677c0731279424992179d098";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coins/bitcoin-cash-bch-logo.svg
// module id = 1105
// module chunks = 2